module.exports = __webpack_public_path__ + "qa.b1303a15.svg";